module.exports = require('./lib/no-important.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/aphrodite/no-important.js
// module id = 14
// module chunks = 0